// extracted by mini-css-extract-plugin
module.exports = {"message":"MeetingMessage_message__32NIt","icon":"MeetingMessage_icon__6ktuz","iframe":"MeetingMessage_iframe__1qIPh"};